"use strict";
module.exports = require("./sidebar");
